import React from 'react';
import PropTypes from 'prop-types';
import './CustomAlert.css';

/**
 * Custom Alert Component
 * @param {boolean} open - Controls visibility
 * @param {function} onClose - Callback when dialog closes
 * @param {string} title - Alert title (optional)
 * @param {string} message - Alert message
 * @param {string} type - 'info'|'success'|'warning'|'error'
 * @param {function} onConfirm - Optional confirm callback for confirmation dialogs
 * @param {string} confirmText - Text for confirm button
 * @param {string} cancelText - Text for cancel button
 */
export default function CustomAlert({
  open,
  onClose,
  title,
  message,
  type = 'info',
  onConfirm,
  confirmText = 'OK',
  cancelText = 'Annuler',
}) {
  if (!open) return null;

  const isConfirm = !!onConfirm;
  const icons = {
    info: 'ℹ️',
    success: '✓',
    warning: '⚠️',
    error: '✗',
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="sp-alert-overlay" onClick={handleCancel}>
      <div
        className={`sp-alert-dialog sp-alert-${type}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sp-alert-header">
          <span className="sp-alert-icon">{icons[type]}</span>
          {title && <h3 className="sp-alert-title">{title}</h3>}
        </div>
        <div className="sp-alert-content">
          <p className="sp-alert-message">{message}</p>
        </div>
        <div className="sp-alert-footer">
          {isConfirm ? (
            <>
              <button className="sp-btn sp-btn--ghost" onClick={handleCancel}>
                {cancelText}
              </button>
              <button
                className="sp-btn sp-btn--primary"
                onClick={handleConfirm}
              >
                {confirmText}
              </button>
            </>
          ) : (
            <button className="sp-btn sp-btn--primary" onClick={handleCancel}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

CustomAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  onConfirm: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};
